import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: LucideIcon;
}

interface PreviewTabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}

export function PreviewTabs({ tabs, activeTab, onChange }: PreviewTabsProps) {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={cn(
                'flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium',
                {
                  'border-indigo-500 text-indigo-600': activeTab === tab.id,
                  'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                    activeTab !== tab.id,
                }
              )}
            >
              <Icon className="h-5 w-5" />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}